import { Directive } from '@angular/core';

@Directive({
    selector: '[ngxAurTableSearchSuffix]',
    standalone: false
})
export class NgxAurTableSearchSuffixDirective {

  constructor() { }

}
